import { useState, type ImgHTMLAttributes } from "react";
import { cn } from "@/lib/cn";

interface SafeImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  fallbackLabel?: string;
}

export function SafeImage({ src, alt, fallbackLabel = "Image unavailable", className, onError, ...props }: SafeImageProps) {
  const [failed, setFailed] = useState(false);
  const label = alt || fallbackLabel;

  if (!src || failed) {
    return (
      <div
        role="img"
        aria-label={label}
        className={cn(
          "grid place-items-center bg-[radial-gradient(circle_at_center,rgba(34,211,238,0.16),transparent_62%)] text-center text-xs font-semibold uppercase tracking-[0.2em] text-cyan-100/70",
          className,
        )}
      >
        <span className="px-3">{fallbackLabel}</span>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={label}
      className={className}
      onError={(event) => {
        setFailed(true);
        onError?.(event);
      }}
      {...props}
    />
  );
}
